import React from "react";
import {
  Phone,
  MessageCircle,
  Mail,
  Instagram,
  Facebook,
  Youtube,
  Heart,
} from "lucide-react";

const PHONE_NUMBER = "+971541873527";
const WHATSAPP_LINK = `https://wa.me/971541873527?text=Hello%20Guru%20Maa,%20I%20would%20like%20to%20schedule%20a%20personalized%20astrology%20consultation.%20Please%20guide%20me.`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", href: "#home" },
    { name: "About", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Gemstones", href: "#gemstones" },
    { name: "Testimonials", href: "#testimonials" },
    { name: "Contact", href: "#contact" },
  ];

  const services = [
    "Horoscope Reading",
    "Kundli Matching",
    "Vastu Consultation",
    "Gemstone Advice",
    "Love & Marriage",
    "Career Guidance",
  ];

  const socialLinks = [
    { icon: Instagram, href: "#", label: "Instagram" },
    { icon: Facebook, href: "#", label: "Facebook" },
    { icon: Youtube, href: "#", label: "Youtube" },
  ];

  return (
    <footer className="relative bg-[#020617] pt-20 pb-8" data-testid="footer">
      {/* Top Divider */}
      <div className="section-divider absolute top-0 left-0 right-0" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {/* Brand Column */}
          <div>
            <h3 className="text-2xl font-bold font-cinzel text-gold-gradient mb-4">
              Guru Maa
            </h3>
            <p className="text-[#94A3B8] text-sm mb-6 leading-relaxed">
              Guiding souls towards their cosmic destiny through ancient Vedic
              wisdom and divine spiritual consultation.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#94A3B8] hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-all"
                    data-testid={`footer-social-${social.label.toLowerCase()}`}
                  >
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="footer-link text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a href="#services" className="footer-link text-sm">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#F8FAFC] font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${PHONE_NUMBER}`}
                  className="flex items-center gap-3 text-[#94A3B8] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={18} className="text-[#D4AF37]" />
                  <span className="text-sm">+971541873527</span>
                </a>
              </li>
              <li>
                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[#94A3B8] hover:text-[#25D366] transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle size={18} className="text-[#25D366]" />
                  <span className="text-sm">WhatsApp Chat</span>
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#94A3B8]">
                <Mail size={18} className="text-[#D4AF37]" />
                <span className="text-sm">gurumataastro76@gmail.com</span>
              </li>
            </ul>

            {/* CTA */}
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 whatsapp-btn px-5 py-2.5 rounded-full text-sm font-semibold"
              data-testid="footer-cta"
            >
              <MessageCircle size={16} />
              <span>Chat Now</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#94A3B8] text-sm text-center md:text-left">
              © {currentYear} Guru Maa Pooja Sharma. All rights reserved.
            </p>
            <p className="text-[#94A3B8] text-sm flex items-center gap-1">
              Made with{" "}
              <Heart size={14} className="text-red-500" fill="currentColor" />{" "}
              for spiritual seekers
            </p>
            <div className="flex gap-6">
              <a href="#privacy-policy" className="footer-link text-sm">
                Privacy Policy
              </a>
              <a href="#" className="footer-link text-sm">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
